"use client";

export function BackgroundOrbits() {
  const loggedInOrbits = [
    { cx: 18, cy: 22, r: 14 },
    { cx: 78, cy: 18, r: 10 },
    { cx: 82, cy: 74, r: 12 },
    { cx: 28, cy: 80, r: 9 },
    { cx: 52, cy: 42, r: 7 },
  ];

  return (
    <div className="dot-bg pointer-events-none fixed inset-0 z-0">
      <svg
        className="absolute inset-0 h-full w-full"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid slice"
      >
        {loggedInOrbits.map((orbit) => (
          <circle
            key={`${orbit.cx}-${orbit.cy}-${orbit.r}`}
            cx={orbit.cx}
            cy={orbit.cy}
            r={orbit.r}
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeOpacity="0.6"
            vectorEffect="non-scaling-stroke"
            className="text-softiq-secondary-shade-300"
          />
        ))}
      </svg>
    </div>
  );
}
